import Header from './components/Header';
import MainCover from './components/MainCover/index';
import AdvanceSummer from './components/AdvanceSummer/index';
import AroundSummer from './components/AroundSummer/index';
import PopDest from './components/PopDest/index';
import HotRecommend from './components/HotRecommend/index';
import UncertainFloor from './components/UncertainFloor';
import SummerBaby from './components/SummerBaby';
import Footer from './components/Footer';
import Rules from './components/Rules';
import VoucherModal from './components/VoucherModal';
// import Lift from './components/Lift'; // 楼层导航，运营要求暂时去掉，换金主后再加回来
import Ads from './components/Ads';
import Voucher from './components/Voucher';
import TopActivity from './components/TopActivity';
import HotNoraml from './components/HotNoraml';
import Hot from './components/Hot';
import AdArea from './components/AdArea';
import Sponsor from './components/Sponsor';
import TimeDown from '$components/TimeDown';
import './index.scss';
import store from './store';
import {Provider, observer, inject} from 'mobx-react';
import {throttle, getQueryString} from 'utils/utils';

const wWidth = window.innerHeight;
window.sendSK = function(eid = '', edata = {}) {
    const QNRSK = window.QNRSK;
    QNRSK && QNRSK.manual(eid, {
        edata
    });
};

const backurl = getQueryString('backurl'); // 华为配置的scheme

// 暑期提前订、广告位、暑期带娃、暑期玩周边、国内热门目的地、不确定楼层、本地遛弯、小驼爆款、金主
const modulesConfig = {
    'sqtqd': <AdvanceSummer />,
    'ggwlc': <Ads />,
    'sqdwbyc': <SummerBaby />,
    'sqwzb': <AroundSummer />,
    'rmmddpz': <PopDest />,
    'bqdlc': <UncertainFloor />,
    'bdlwtj': <HotNoraml />,
    'xtbkmk': <Hot />,
    'jzbblc': <Sponsor />
};

@inject(({store}) => ({
    init: store.init,
    loading: store.loading,
    hasMore: store.hasMore,
    loadMore: store.loadMore,
    jump: store.jump,
    ymbj: store.ymbj,
    showRules: store.showRules
}))
@observer
class App extends React.Component {
    createRef(cmp) {
        this.hrRefs = cmp;
    }
    componentDidMount() {
        this.props.init();
        document.querySelector('#container').addEventListener('scroll', throttle(this.handeScroll.bind(this), 200));
    }

    handeScroll() {
        if(!this.hrRefs || !QNR) return;
        const {loading, hasMore, loadMore} = this.props;
        const flexFont = QNR.Flexible.fontSize;
        const {bottom} = this.hrRefs.getBoundingClientRect();
        const getBottom = (wWidth - bottom) - (0.63 * flexFont);
        if(!loading && hasMore && Math.abs(getBottom) <= 10) {
            // 加载数据
            loadMore && loadMore();
        }
    }

    sequentialDisplay() {
        const {ymbj={}} = this.props;
        const {midList=[]} = ymbj;
        if(midList.length === 0) return null;
        return midList.map((val, idx) => {
            return (
                <React.Fragment>
                    {ymbj[val.type] && ymbj[val.type].switch === 1 && modulesConfig[val.type] || null}
                    <AdArea floorId={(idx + 1) + ''} />
                </React.Fragment>
            );
        });
    }

    render() {
        return (
            <React.Fragment>
                <div className={`main ${this.props.showRules ? 'disable' : ''}`} id="container">
                    <Header/>
                    <MainCover/>
                    <TopActivity />
                    <Voucher />
                    {
                        this.sequentialDisplay()
                    }
                    <HotRecommend createRef={this.createRef.bind(this)}/>
                </div>
                <Footer jump={this.props.jump}/>
                <Rules/>
                <VoucherModal />
                <TimeDown />
                {
                    backurl && (
                        <div className="huawei-back"
                            onClick={() => {
                                window.location.href = backurl;
                            }}>
                            <span className="yo-ico">&#xf07d;</span>
                        </div>
                    )
                }
            </React.Fragment>
        );
    }
}


ReactDOM.render(<Provider store={store}><App/></Provider>, document.querySelector('#app'));